export const workflowQuickStartSteps = [1, 2, 3];
export const templateQuickStartSteps = [1, 2, 3];
